export var SHOPGATE_USER_REGISTER='shopgate.user.register';